// CRM Quotations - async thunks (Redux Toolkit createAsyncThunk), reduced in ./quotationSlice.js.
// All requests are POSTs through the shared axios instance and always include the logged-in user's client_id.
// Endpoints come from src/config/apiRoutes.js (QUOTATION_TEMPLATES, QUOTATION_LOGS, ADD_QUOTATION_LOG under /general).
import api from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../config/apiRoutes";


/**✅ quotation Templates Thunk **/
// Fetches the product/item templates for this client.
// POST /general/quotation-templates  body: { client_id }  -> resolves with the `data` array.
// Cached: returns the templates already in the store unless called with { type: "crmQuotationTemplates" } to force a refresh.
export const getQuotationTemplateThunk = createAsyncThunk(
    "crmQuotation/getQuotationTemplateThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        if (payload.type !== "crmQuotationTemplates") {
            if (state.crmQuotation?.quotationTemplates?.length > 0) {
                return state.crmQuotation.quotationTemplates;
            }
        }

        try {
            const response = await api.post(API_ROUTES.QUOTATION_TEMPLATES, {
                "client_id": user?.client_id
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch quotation templates");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);


/**✅ quotation Logs Thunk **/
// Fetches every quotation already sent for this client (one entry per quotation).
// POST /general/quotation-logs  body: { client_id }  -> resolves with the `data` array.
// Cached like the templates; pass { type: "crmQuotationLog" } to force a refresh (done after a new quotation is sent).
export const getQuotationLogThunk = createAsyncThunk(
    "crmQuotation/getQuotationLogThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        if (payload.type !== "crmQuotationLog") {
            if (state.crmQuotation?.quotationLogs?.length > 0) {
                return state.crmQuotation.quotationLogs;
            }
        }

        try {
            const response = await api.post(API_ROUTES.QUOTATION_LOGS, {
                "client_id": user?.client_id
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch quotation Logs");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);



/**✅addQuotationLogThunk **/
// Saves a sent quotation to the log. Called as dispatch(addQuotationLogThunk({ credentials })).
// POST /general/add-quotation-log  body: { wa_contact_id, quotation_path (uploaded PDF URL), quotation_no, client_id }.
// Succeeds only on statusCode 201 and resolves with { success: true, message }.
export const addQuotationLogThunk = createAsyncThunk(
    "crmQuotation/addQuotationLogThunk",
    async ({ credentials }, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            "client_id": user?.client_id
        };

        try {
            const response = await api.post(API_ROUTES.ADD_QUOTATION_LOG, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Quotation Adding failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Quotation Adding failed"
            );
        }
    }
);